import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';

// Отладочная информация
// React не пускает переменные, которые не начинаются с REACT_APP_...
console.log('Запуск приложения: ', process.env);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter basename={process.env.REACT_APP_ADMIN_URL || process.env.REACT_APP_PUBLIC_URL || '/'}>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
  // </React.StrictMode>
);